"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doMigrateFi = exports.doUpdateFi = exports.doUpdateCredentials = exports.doReAuthenticate = exports.doProvideCredentialsAndRefresh = exports.doAccountRediscovery = exports.doAccountDiscovery = exports.logPlaidItemEventResponse = exports.logPlaidItemEvent = exports.accountDiscoveryWidgetUpdateSuccess = exports.discoverInstitutionLoginWithAccountsDiscard = exports.discoverInstitutionLoginWithAccountsResponse = exports.discoverInstitutionLoginWithAccountsByPolling = exports.discoverInstitutionLoginWithAccounts = exports.accountDiscoveryError = exports.accountDiscoveryStopped = exports.accountDiscoveryFailure = exports.accountDiscoverySuccess = exports.accountDiscoverySuccessWithAccounts = exports.getAggregationInfo = exports.getPartnerAuthUrisFailure = exports.getPartnerAuthUrisSuccess = exports.getPartnerAuthUris = exports.accountDiscoveryMfaFormSubmitResponse = exports.accountDiscoveryMfaFormSubmit = exports.accountDiscoveryMfaRequired = exports.accountDiscoveryStatus = exports.accountDiscoveryCredentialsFormSubmitResponse = exports.accountDiscoveryCredentialsFormSubmit = exports.institutionSelected = exports.accountDiscoveryCleanup = exports.accountDiscoverySetup = void 0;
const redux_actions_1 = require("redux-actions");
const immutable_1 = require("immutable");
const uuid_1 = require("uuid");
const root_ui_1 = require("companion-app-components/flux/root-ui");
const actions_1 = require("data/institutionLogins/actions");
const actionHelpers_1 = require("utils/actionHelpers");
const types_1 = require("./types");
exports.accountDiscoverySetup = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_SETUP');
exports.accountDiscoveryCleanup = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_CLEANUP');
exports.institutionSelected = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_INSTITUTION_SELECTED');
exports.accountDiscoveryCredentialsFormSubmit = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_CREDENTIALS_FORM_SUBMIT');
exports.accountDiscoveryCredentialsFormSubmitResponse = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_CREDENTIALS_FORM_SUBMIT_SUCCESS');
exports.accountDiscoveryStatus = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_STATUS');
exports.accountDiscoveryMfaRequired = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_MFA_REQUIRED');
exports.accountDiscoveryMfaFormSubmit = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_MFA_FORM_SUBMIT');
exports.accountDiscoveryMfaFormSubmitResponse = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_MFA_FORM_SUBMIT_RESPONSE');
exports.getPartnerAuthUris = (0, actionHelpers_1.createAction)('GET_PARTNER_AUTH_URIS');
exports.getPartnerAuthUrisSuccess = (0, actionHelpers_1.createAction)('GET_PARTNER_AUTH_URIS_SUCCESS');
exports.getPartnerAuthUrisFailure = (0, actionHelpers_1.createAction)('GET_PARTNER_AUTH_URIS_FAILURE');
exports.getAggregationInfo = (0, actionHelpers_1.createAction)('GET_AGGREGATION_INFO');
exports.accountDiscoverySuccessWithAccounts = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_SUCCESS_WITH_ACCOUNTS');
exports.accountDiscoverySuccess = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_SUCCESS');
exports.accountDiscoveryFailure = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_FAILURE');
exports.accountDiscoveryStopped = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_STOPPED');
exports.accountDiscoveryError = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_ERROR');
exports.discoverInstitutionLoginWithAccounts = (0, actionHelpers_1.createAction)('DISCOVER_INSTITUTION_LOGIN_WITH_ACCOUNTS');
exports.discoverInstitutionLoginWithAccountsByPolling = (0, actionHelpers_1.createAction)('DISCOVER_INSTITUTION_LOGIN_WITH_ACCOUNTS_BY_POLLING');
exports.discoverInstitutionLoginWithAccountsResponse = (0, actionHelpers_1.createAction)('DISCOVER_INSTITUTION_LOGIN_WITH_ACCOUNTS_RESPONSE');
exports.discoverInstitutionLoginWithAccountsDiscard = (0, actionHelpers_1.createAction)('DISCOVER_INSTITUTION_LOGIN_WITH_ACCOUNTS_DISCARD');
exports.accountDiscoveryWidgetUpdateSuccess = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_PLAID_ITEM_UPDATE_SUCCESS');
exports.logPlaidItemEvent = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_LOG_PLAID_ITEM_EVENT');
exports.logPlaidItemEventResponse = (0, actionHelpers_1.createAction)('ACCOUNT_DISCOVERY_LOG_PLAID_ITEM_EVENT_RESPONSE');
exports.doAccountDiscovery = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (options = {}) => root_ui_1.rootUiTypes.mkRootUiData({
    id: (0, uuid_1.v4)(),
    type: types_1.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
    allowNesting: true,
    props: (0, immutable_1.Map)((0, types_1.mkAccountDiscoveryDialogProps)({
        initiator: options.initiator || 'unknown',
        mode: options.mode || 'ADD-FI',
    })),
}), (_, meta) => meta);
exports.doAccountRediscovery = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (institutionLogin, options = {}) => root_ui_1.rootUiTypes.mkRootUiData({
    id: (0, uuid_1.v4)(),
    type: types_1.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
    allowNesting: true,
    props: (0, immutable_1.Map)((0, types_1.mkAccountDiscoveryDialogProps)({
        initiator: options.initiator || 'unknown',
        mode: 'ACCOUNT-REDISCOVERY',
        institutionLogin,
        afterCloseAction: (0, actions_1.refreshAccounts)({ institutionLoginId: institutionLogin.id }),
    })),
}), (_, meta) => meta);
exports.doProvideCredentialsAndRefresh = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (institutionLogin, options = {}) => root_ui_1.rootUiTypes.mkRootUiData({
    id: (0, uuid_1.v4)(),
    type: types_1.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
    allowNesting: false,
    props: (0, immutable_1.Map)((0, types_1.mkAccountDiscoveryDialogProps)({
        initiator: options.initiator || 'unknown',
        mode: 'PROVIDE-CREDENTIALS',
        institutionLogin,
        afterCloseAction: (0, actions_1.refreshAccounts)({ institutionLoginId: institutionLogin.id }),
    })),
}), (_, meta) => meta);
exports.doReAuthenticate = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (institutionLogin) => root_ui_1.rootUiTypes.mkRootUiData({
    id: (0, uuid_1.v4)(),
    type: types_1.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
    allowNesting: false,
    props: (0, immutable_1.Map)((0, types_1.mkAccountDiscoveryDialogProps)({
        mode: 'RE-AUTHENTICATE',
        institutionLogin,
        afterCloseAction: (0, actions_1.refreshAccounts)({ institutionLoginId: institutionLogin.id }),
    })),
}));
exports.doUpdateCredentials = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (institutionLogin) => root_ui_1.rootUiTypes.mkRootUiData({
    id: (0, uuid_1.v4)(),
    type: types_1.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
    allowNesting: false,
    props: (0, immutable_1.Map)((0, types_1.mkAccountDiscoveryDialogProps)({
        mode: 'UPDATE-CREDENTIALS',
        institutionLogin,
        afterCloseAction: (0, actions_1.refreshAccounts)({ institutionLoginId: institutionLogin.id }),
    })),
}));
exports.doUpdateFi = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), ({ institutionLogin, clearInstitution = false }) => root_ui_1.rootUiTypes.mkRootUiData({
    id: (0, uuid_1.v4)(),
    type: types_1.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
    allowNesting: false,
    props: (0, immutable_1.Map)((0, types_1.mkAccountDiscoveryDialogProps)({
        mode: 'UPDATE-FI',
        institutionLogin: clearInstitution
            ? institutionLogin.merge({ institutionId: null, cpInstitutionId: null, brandingId: null })
            : institutionLogin,
        // afterCloseAction: refreshAccounts({ institutionLoginId: institutionLogin.id }),
    })),
}));
exports.doMigrateFi = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (institutionLogin, aggAction) => root_ui_1.rootUiTypes.mkRootUiData({
    id: (0, uuid_1.v4)(),
    type: types_1.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
    allowNesting: false,
    props: (0, immutable_1.Map)((0, types_1.mkAccountDiscoveryDialogProps)({
        mode: 'MIGRATE-INSTITUTION-LOGIN',
        institutionLogin,
        aggAction,
    })),
}));
